import cls from "classnames"
import { chunk } from "lodash-es"
import { useEffect, useMemo, useState } from "react"

import { getDrawInfo, type DrawInfo } from "@/services/core"
import StrokeText from "@/components/StrokeText"
import { i18n } from "@/i18n"
import { useRoleInfo } from "@/user/session"
import { RECALL_REWARD_MAP } from "../../const/reward"

import styles from "./index.module.scss"

export const Reward: React.FC = () => {
    const [drawInfo, setDrawInfo] = useState<DrawInfo | null>(null)
    const user = useRoleInfo()

    useEffect(() => {
        if (!user) return
        getDrawInfo().then((res) => {
            if (res.code === 0) {
                setDrawInfo(res.data)
            }
        })
    }, [user])

    const rewardList = useMemo(() => {
        if (!drawInfo?.coupons) {
            return []
        }
        return drawInfo.coupons.filter(
            (q) =>
                !!q.result &&
                q.result?.giftName &&
                q.cid === __RECALL_COUPON_CID,
        )
    }, [drawInfo])

    return (
        <div className={styles.reward}>
            {rewardList.length ? (
                <div className={styles.list}>
                    {rewardList.map((q, index) => {
                        const reward = RECALL_REWARD_MAP[q.result!.giftName]
                        if (!reward) {
                            return null
                        }

                        const { src, title: name, amount } = reward

                        if (name.length > 6) {
                            const lines = chunk(
                                `${name}x${amount}`.split(""),
                                6,
                            )
                            return (
                                <div key={index} className={styles.reward}>
                                    <div
                                        className={styles.icon}
                                        style={{
                                            backgroundImage: `url(${src})`,
                                        }}
                                    />
                                    {lines.map((line, index) => (
                                        <div
                                            key={index}
                                            className={styles.line}
                                        >
                                            {line.map((char, index) => (
                                                <StrokeText
                                                    key={index}
                                                    text={char}
                                                    fontFamily="a한글세상B"
                                                    fontSize={29}
                                                    fillColor="#8f7254"
                                                    borderWidth={3}
                                                    borderColor="#fffbf7"
                                                    offsetY={0}
                                                    padding={3}
                                                    baselineAligned
                                                    className={styles.text}
                                                />
                                            ))}
                                        </div>
                                    ))}
                                </div>
                            )
                        }

                        return (
                            <div key={index} className={styles.reward}>
                                <div
                                    className={styles.icon}
                                    style={{ backgroundImage: `url(${src})` }}
                                />
                                <div className={styles.line}>
                                    <StrokeText
                                        text={name}
                                        fontFamily="a한글세상B"
                                        fontSize={29}
                                        fillColor="#8f7254"
                                        borderWidth={3}
                                        borderColor="#fffbf7"
                                        offsetY={0}
                                        padding={3}
                                        baselineAligned
                                    />
                                </div>
                                <div className={styles.line}>
                                    <StrokeText
                                        text={`x${amount}`}
                                        fontFamily="a한글세상B"
                                        fontSize={29}
                                        fillColor="#8f7254"
                                        borderWidth={3}
                                        borderColor="#fffbf7"
                                        offsetY={0}
                                        padding={3}
                                        baselineAligned
                                    />
                                </div>
                            </div>
                        )
                    })}
                </div>
            ) : (
                <div className={cls(styles.tips, styles.small)}>
                    <div className={styles.arrow} />
                    <div className={styles.text}>
                        <StrokeText
                            text={i18n.getRecall("record.empty")}
                            fontFamily="a한글세상B"
                            fontSize={36}
                            fillColor="#fff9ed"
                            borderWidth={3}
                            borderColor="#614518"
                            offsetY={0}
                            padding={3}
                            baselineAligned
                        />
                    </div>
                    <div className={styles.arrow} />
                </div>
            )}
        </div>
    )
}
